import Button from '@mui/material/Button';
import FadeIn from "react-fade-in/lib/FadeIn"
import { useDispatch, useSelector } from "react-redux";
import {
  setStepRedux,
  setOpenThemeRedux,
  getOpenThemeRedux,
  setSlidePageRedux,
  getSlidePageRedux,
  setPrimeColorPickerOpenRedux,
  getPrimeColorPickerOpenRedux,
  setSecondColorPickerOpenRedux,
  getSecondColorPickerOpenRedux,
  setCancleCreatePortalModalRedux,
  getCancleCreatePortalModalRedux,
  setCancleCreateThemePortalModalRedux,
  getCancleCreateThemePortalModalRedux,
  setAcceptCreatePortalModalRedux,
  getAcceptCreatePortalModalRedux,
  setSwitchActivePortalRedux,
  getSwitchActivePortalRedux,
} from "../../../libs/eduPortalManagementSlice";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect, useMemo } from "react";
import ErrorIcon from '@mui/icons-material/Error';
import { hex2rgb } from "string-color-converter";
import './styleportal.css'
import { rgbaStringToHex } from "../../../lib/FormPortal/colorConvert";
import PortalFormBody from "../../../lib/FormPortal/PortalFormBody";
import { isPortalSaveDisabled } from "../../../lib/FormPortal/portalFormValidation";
import fontColor from "../../../lib/fontColor";
import { getBizID, getLogo } from "../../../libs/todoSlice";
import { getValidLoginMethods } from "../../../lib/FormPortal/loginMethodRules";

const EduPortalManagementCreatePortal = () => {

  const dispatch = useDispatch()
  const biz_id = useSelector(getBizID)
  const logo = useSelector(getLogo)
  const openTheme = useSelector(getOpenThemeRedux)
  const slidepage = useSelector(getSlidePageRedux)
  const primecolorpickeropen = useSelector(getPrimeColorPickerOpenRedux)
  const secondcolorpickeropen = useSelector(getSecondColorPickerOpenRedux)
  const canclecreateportalmodal = useSelector(getCancleCreatePortalModalRedux)
  const canclecreatethemeportalmodal = useSelector(getCancleCreateThemePortalModalRedux)
  const acceptcreateportalmodal = useSelector(getAcceptCreatePortalModalRedux)
  const switchactiveportal = useSelector(getSwitchActivePortalRedux)
  const [autoApprove, setAutoApprove] = useState(true)
  const [formName, setFormName] = useState('')
  const [formType, setFormType] = useState('')
  const [active, setActive] = useState(true)
  const [retrieve, setRetrieve] = useState([])

  const [idp, setIDP] = useState([])   // raw list จาก API เท่านั้น — ห้าม setIDP(idp.filter(...)) อีก

  const visibleIdp = useMemo(() => {
      if (formType === "connect-mail") {
          return idp.filter(method => method.name === "Google" || method.name === "Azure");
      }
      if (formType === "general-mail") {
          return idp.filter(method => method.name !== "OneID");
      }
      return idp;
  }, [idp, formType]);

  const [loginmethod, setLoginMethod] = useState([])
  const [link, setLink] = useState('')
  const [token, setToken] = useState('')
  const [useClientSecret, setUseClientSecret] = useState(false)
  const [clientKey, setClientKey] = useState('')
  const [secretKey, setSecretKey] = useState('')
  const [clientIDList, setClientIDList] = useState([])
  const [portalthemename, setPortalThemeNameValue] = useState('')
  const [portalthemeprimecolor, setPortalThemePrimeColorValue] = useState(rgbaStringToHex("rgba(62, 148, 181, 1)"))
  const [portalthemesecondcolor, setPortalThemeSecondColorValue] = useState(rgbaStringToHex("rgba(43, 161, 151, 1)"))
  const [redirect_url, setRedirectURL] = useState('')
  const [client_id, setClientID] = useState('')
  const [azureurl, setAzureURL] = useState('')
  const [googleurl, setGoogleURL] = useState('')
  const [facebookurl, setFacebookURL] = useState('')
  const [onecollaburl, setOneCollabURL] = useState('')
  const [portalthemeprimecolorpick, setPortalThemePrimeColorPick] = useState({})
  const [portalthemesecondcolorpick, setPortalThemeSecondColorPick] = useState({})
  const [timeleft, setTimeLeft] = useState(0)
  const [useCA, setUseCA] = useState(false)
  const [portallogo, setPortalLogo] = useState('')
  const [contact, setContact] = useState('')
  const [updateRealTime, setUpdateRealTime] = useState(false)

  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action
    }))
  }

  const setOpenTheme = (action) => {
    dispatch(setOpenThemeRedux({
      openTheme: action
    }))
  }

  const setPortalThemeName = (action) => {
    setPortalThemeNameValue(action)
  }

  const setPortalThemePrimeColor = (action) => {
    setPortalThemePrimeColorValue(action)
  }

  const setPortalThemeSecondColor = (action) => {
    setPortalThemeSecondColorValue(action)
  }

  const setPrimeColorPickerOpen = (action) => {
    dispatch(setPrimeColorPickerOpenRedux({
      primecolorpickeropen: action
    }))
  }

  const setSecondColorPickerOpen = (action) => {
    dispatch(setSecondColorPickerOpenRedux({
      secondcolorpickeropen: action
    }))
  }

  const setSlidePage = (action) => {
    dispatch(setSlidePageRedux({
      slidepage: action
    }))
  }

  const setCancleCreatePortalModal = (action) => {
    dispatch(setCancleCreatePortalModalRedux({
      canclecreateportalmodal: action
    }))
  }

  const setCancleCreateThemePortalModal = (action) => {
    dispatch(setCancleCreateThemePortalModalRedux({
      canclecreatethemeportalmodal: action
    }))
  }

  const setAcceptCreatePortalModal = (action) => {
    dispatch(setAcceptCreatePortalModalRedux({
      acceptcreateportalmodal: action
    }))
  }

  const setSwitchActivePortal = (action) => {
    dispatch(setSwitchActivePortalRedux({
      switchactiveportal: action
    }))
  }

  useEffect(() => {
    
    getIDP()
    setOpenTheme(false)
    setCancleCreateThemePortalModal(false)
    setCancleCreatePortalModal(false)
    setAcceptCreatePortalModal(false)
    setSlidePage(1)
    setFormName('')
    setFormType('')
    setAutoApprove(true)
    setActive(true)
    setLoginMethod([])
    setRetrieve([])
    setToken('')
    setLink('')
    setClientIDList([])
    setPortalThemeName('')
    setPortalLogo('')
    setPortalThemePrimeColor(rgbaStringToHex("rgba(62, 148, 181, 1)"))
    setPortalThemeSecondColor(rgbaStringToHex("rgba(43, 161, 151, 1)"))
    setPortalThemePrimeColorPick(rgbaStringToHex("rgba(62, 148, 181, 1)"))
    setPortalThemeSecondColorPick(rgbaStringToHex("rgba(43, 161, 151, 1)"))
    setPrimeColorPickerOpen(false)
    setSecondColorPickerOpen(false)
    setRedirectURL(process.env.REACT_APP_ONE_ID + "/login?shared_token=")
    setClientID('')
    setAzureURL('')
    setGoogleURL('')
    setFacebookURL('')
  }, [])

  const addPortal = async () => {
    setTimeLeft(3)
    let timeLeftTemp = 3
    const interval = setInterval(() => {
      timeLeftTemp--
      setTimeLeft(timeLeftTemp);
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
      setTimeLeft(0);
    }, 3000);

    try {
      const oneIdObject = retrieve.find(item => item.from === "OneID");
      const retrieveData = []
      if (formType === "corporation-pre-register" && oneIdObject) {
          if (oneIdObject.cid) retrieveData.push(oneIdObject.cid)
          if (oneIdObject.corporation_Id) retrieveData.push(oneIdObject.corporation_Id)
          if (oneIdObject.email) retrieveData.push(oneIdObject.email)
      }

      var portalPayload = {
        name: formName,
        retrieveData: retrieveData,
        kind: formType,
        contact: contact,
        approvalMethod: {
          autoApprove: autoApprove,
          clientIDList: clientIDList
        },
        active: active,
        loginMethod: loginmethod,
        retrieve: retrieve,
        redirectURL: redirect_url,
        clientID: client_id,
        useCA: useCA
      }

      if (formType === "connect-mail" || formType === "general-mail") {
        portalPayload.updateRealTime = updateRealTime
      }

      const { data } = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal`,
        data: {
          business_id: biz_id,
          portal: portalPayload
        }

      })

      const formData = new FormData();
      formData.append('name', portalthemename === "" ? "default" : portalthemename)
      formData.append('primary_color', JSON.stringify(hex2rgb(portalthemeprimecolor)))
      formData.append('secondary_color', JSON.stringify(hex2rgb(portalthemesecondcolor)))
      formData.append('image_logo', portallogo)
      formData.append('portal_id', data.data.id)
      formData.append('business_id', biz_id)

      await axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal/theme`,
        data: formData
      })
      setStep('table')
      Swal.fire({
        title: 'บันทึก Portal สำเร็จแล้ว',
        icon: 'success'
      })

    } catch (err) {
      setStep('table')
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'บันทึก Portal ไม่สำเร็จ'
      })
    }
  }

  const getIDP = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal/idps`,
        params: { business_id: biz_id },
      });
      setIDP(data?.data?.idp_list ?? []);
    } catch (err) {
      setIDP([]);
    }
  };

  useEffect(() => {
    if (portallogo) {
      const fileReader = new FileReader();
      fileReader.onload = handleImageLoad;
      fileReader.readAsDataURL(portallogo);
    }
  }, [portallogo]);

  useEffect(() => {
      if (formType === "general" || formType === "medical-pre-register" || formType === "time-attendance-pre-register") {
          setUseCA(false);
      }
      if (formType === "corporation-pre-register" && !retrieve.some(obj => obj.from === "OneID")) {
        setRetrieve([...retrieve, { from: "OneID", url: null, token: null, corporation_Id: "corporation_Id" }]);
      }
  }, [formType]);

  const handleFormTypeChange = (newFormType) => {
      setFormType(newFormType);
      setLoginMethod((prev) => getValidLoginMethods(prev, newFormType));
  };

  const handleImageLoad = (event) => {
    const image = new Image();
    image.src = event.target.result;

    image.onload = () => {
    };

    image.onerror = () => {
      Swal.fire({
        icon: 'error',
        title: 'ไฟล์ไม่ถูกต้อง',
        text: 'กรุณาอัปโหลดไฟล์ประเภท PNG JPG JPEG',
        className: 'swal2-container'
      })
      setPortalLogo('');
    };
  };

  const handleChangeImage = (e) => {
    setPortalLogo(e.target.files[0])
    if (e.target.files[0]) {
      const maxSize = 2 * 1024 * 1024
      if (e.target.files[0].size > maxSize) {
        setPortalLogo("")
        e.target.value = "";
        Swal.fire({
          icon: 'error',
          title: 'ไฟล์รูปมีขนาดใหญ่เกินไป',
          footer: 'ไฟล์ต้องมีขนาดไม่เกิน 2 MB'
        })
      }
    }
  }

  const formBodyProps = {
    mode: 'create',
    primaryColor: portalthemeprimecolor,
    active,
    onRequestToggleActive: () => setSwitchActivePortal(true),
    formName,
    onFormNameChange: setFormName,
    onOpenTheme: () => setOpenTheme(true),
    formType,
    onFormTypeChange: handleFormTypeChange,
    formTypeDisabled: false,
    useCA,
    onToggleUseCA: () => setUseCA((prev) => !prev),
    autoApprove,
    approvalMethodDisabled: false,
    onSetAutoApprove: setAutoApprove,
    clientIDList,
    setClientIDList,
    loginMethod: loginmethod,
    onLoginMethodChange: setLoginMethod,
    idp: visibleIdp,
    retrieveUrlSetters: {
      Azure: setAzureURL,
      Google: setGoogleURL,
      Facebook: setFacebookURL,
      OneCollab: setOneCollabURL,
    },
    retrieve,
    setRetrieve,
    retrieveFieldValues: {
      link,
      setLink,
      token,
      setToken,
      azureurl,
      setAzureURL,
      googleurl,
      setGoogleURL,
      facebookurl,
      setFacebookURL,
      onecollaburl,
      setOneCollabURL,
      useClientSecret,
      setUseClientSecret,
      clientKey,
      setClientKey,
      secretKey,
      setSecretKey,
    },
    redirectUrl: redirect_url,
    onRedirectUrlChange: (value) => setRedirectURL(value),
    clientId: client_id,
    onClientIdChange: (value) => setClientID(value),
    showUpdateRealTime: formType === 'connect-mail' || formType === 'general-mail',
    updateRealTime,
    onToggleUpdateRealTime: () => setUpdateRealTime((prev) => !prev),
    contact,
    onContactChange: setContact,
    cancelPortalDialogProps: {
      open: canclecreateportalmodal,
      onClose: () => setCancleCreatePortalModal(false),
      title: 'คุณต้องการยกเลิก Portal form ใช่ไหม',
      message: 'หากคุณยกเลิกข้อมูลจะไม่บันทึก',
      onConfirm: () => setStep('table'),
      primaryColor: portalthemeprimecolor,
      titleFontWeight: '600',
      buttonRowMarginTop: '20px',
      buttonRowFontSize: '16px',
      buttonRowFontWeight: '500',
      cancelMarginRight: '20px',
    },
    acceptPortalDialogProps: {
      open: acceptcreateportalmodal,
      onClose: () => setAcceptCreatePortalModal(false),
      title: 'ต้องการบันทึกข้อมูลใช่ไหม',
      message: 'คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล',
      onConfirm: () => addPortal(),
      loading: timeleft > 0,
      primaryColor: portalthemeprimecolor,
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
    },
    switchActiveDialogProps: {
      open: switchactiveportal,
      onClose: () => setSwitchActivePortal(false),
      title: active ? 'คุณต้องการให้สถานะ Inactive' : 'คุณต้องการให้สถานะ Active',
      message: active
        ? 'Portal form สถานะ inactive จะไม่สามารถใช้งานได้'
        : 'Portal form สถานะ active จะสามารถเข้าใช้งานได้',
      onConfirm: () => {
        setActive(!active);
        setSwitchActivePortal(false);
      },
      primaryColor: portalthemeprimecolor,
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
    },
    cancelThemeDialogProps: {
      open: canclecreatethemeportalmodal,
      onClose: () => setCancleCreateThemePortalModal(false),
      icon: <ErrorIcon style={{ width: '72px', height: '72px', color: '#F2BE47' }} />,
      title: 'คุณต้องการยกเลิก',
      message: 'หากคุณต้องการยกเลิกข้อมูลทั้งหมดจะหายไป',
      onConfirm: () => {
        setCancleCreateThemePortalModal(false);
        setOpenTheme(false);
        setPortalThemePrimeColorPick(portalthemeprimecolor);
        setPortalThemeSecondColorPick(portalthemesecondcolor);
      },
      primaryColor: portalthemeprimecolor,
      boxHeight: '256px',
      titleFontWeight: '600',
      titleMarginTop: '5px',
      buttonRowMarginTop: '30px',
      buttonRowFontWeight: null,
      cancelMarginRight: '20px',
    },
    themeModalProps: {
      open: openTheme,
      onClose: () => setOpenTheme(false),
      themeName: portalthemename,
      onThemeNameChange: setPortalThemeName,
      primaryColorPick: portalthemeprimecolorpick,
      onPrimaryColorPick: setPortalThemePrimeColorPick,
      secondaryColorPick: portalthemesecondcolorpick,
      onSecondaryColorPick: setPortalThemeSecondColorPick,
      primaryPickerOpen: primecolorpickeropen,
      onTogglePrimaryPicker: setPrimeColorPickerOpen,
      secondaryPickerOpen: secondcolorpickeropen,
      onToggleSecondaryPicker: setSecondColorPickerOpen,
      closeOtherPickerOnOpen: true,
      hasLogo: Boolean(portallogo),
      logoSrc: portallogo ? URL.createObjectURL(portallogo) : `data:image/png;base64, ${logo}`,
      onLogoChange: handleChangeImage,
      onLogoClear: () => setPortalLogo(''),
      logoAccept: '.jpg, .jpeg, .png',
      onResetTheme: () => {
        setPortalThemePrimeColorPick(rgbaStringToHex('rgba(62, 148, 181, 1)'));
        setPortalThemeSecondColorPick(rgbaStringToHex('rgba(43, 161, 151, 1)'));
        setPortalLogo('');
      },
      slidePage: slidepage,
      setSlidePage: setSlidePage,
      slide1NavTop: '86%',
      committedPrimaryColor: portalthemeprimecolor,
      onRequestCancel: () => setCancleCreateThemePortalModal(true),
      onCommitPrimaryColor: setPortalThemePrimeColor,
      onCommitSecondaryColor: setPortalThemeSecondColor,
    },
  };

  return (
    <FadeIn>
      <PortalFormBody {...formBodyProps}>
        <div className="row mt-2 justify-content-center" style={{ marginBottom: '30px' }}>
          <div className="col-md-5 col-5 text-md-end">
            <Button
              variant="outlined"
              style={{
                marginTop: '15px',
                width: '130px',
                height: '36px',
                marginRight: '10px',
                borderColor: portalthemeprimecolor,
                color: portalthemeprimecolor,
              }}
              sx={{
                '&:hover': { borderColor: fontColor(portalthemeprimecolor) },
                ...(!!portalthemesecondcolor
                  ? { borderColor: portalthemeprimecolor, color: fontColor(portalthemeprimecolor) }
                  : { background: '#053075' }),
              }}
              onClick={() => setCancleCreatePortalModal(true)}
            >ยกเลิก</Button>
          </div>
          <div className="col-md-5 col-5 text-md-start">
            <Button
              variant="contained"
              onClick={() => setAcceptCreatePortalModal(true)}
              style={{
                marginTop: '15px',
                width: '130px',
                height: '36px',
              }}
              sx={!!portalthemesecondcolor ? {
                backgroundColor: `${portalthemeprimecolor} !important`,
                color: fontColor(portalthemeprimecolor)
              } : {
                background: '#053075'
              }}
              disabled={isPortalSaveDisabled({
                formName,
                formType,
                loginMethod: loginmethod,
                retrieve,
                link,
                token,
                redirectUrl: redirect_url,
                clientId: client_id,
                azureUrl: azureurl,
                googleUrl: googleurl,
                facebookUrl: facebookurl,
                useClientSecret, 
                clientKey, 
                secretKey,
              })}
            >บันทึก</Button>
          </div>
        </div>
      </PortalFormBody>
    </FadeIn>
  );
};

export default EduPortalManagementCreatePortal